import React, {useEffect, useState } from 'react'
import { InputGroup, Modal, Button, Form, Col, Row} from "react-bootstrap";
import Select from "react-select";
import useGetAllCategories from '../../ReuseApi/useGetAllCategories';
import useGetAllProjects from '../../ReuseApi/useGetAllProjects';
import useGetDepartments from '../../ReuseApi/useGetDepartments';
import useGetAssignTo from '../../ReuseApi/useGetAssignTo';
import axios from 'axios';
import * as Icon from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useSelector } from 'react-redux';

const AssignToDoModel = ({ show, close,item ,fetchData}) => {

  const taskPriorityOptions = [{ value: 'normal', label: 'Normal' }, { value: 'medium', label: 'Medium' }, { value: 'immediate', label: 'Immediate' }];
  const loginUserData = useSelector((state) => state.loginData.userData)

  // const userDataDept = loginUserData.department.map((itm) => { return itm.label })
  const userDataDept = loginUserData?.department.map((itm) => { return itm.label }).toString()
  const userDept = loginUserData?.department.map((itm) => { return itm.label }).toString()

  const AddTaskSuccess = (res) => {
      toast.success("Assigned Task Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose:1000,
      });
    }

  const InitialHrMinute = () =>{
      toast.error("00 hours and 00 minutes at the same time are not permitted, please choose an acceptable time.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose:1000,
      });
  }

  const handlerDelete = () => {
    const payload1 = {
        toDoListId: item?.toDoListId
    }
    axios.post(process.env.REACT_APP_BASE_URL + "/toDoList/deleteToDoList",payload1)
    .then((res) => {
        console.log("response",res)
    })
    .catch((err) => {
      console.log("Error:",err)
    })

  }

  const [taskpriority, setTaskpriority] = useState("")
  const [departmentName, setDepartmentName] = useState([])
  const [projectname, setProjectname] = useState("")
  const [categoryname, setCategoryname] = useState("")
  const [assignto, setAssignto] = useState("")
  const [proposedStartDate, setProposedStartDate] = useState("")
  const [proposedEndDate, setProposedEndDate] = useState("")
  const [initialHr, setInitialHr] = useState("")
  const[initialminute,setInitialMinute] = useState("")


  // for error handling
  const [taskPriorityErrr, setTaskPriorityErr] = useState(false)
  const [tastDeptErr, setTaskDeptErr] = useState(false)
  const [projectNameErr, setProjectNameErr] = useState(false)
  const [categoryNameError, setCategoryNameError] = useState(false)
  const [assignToErr, setAssignToErr] = useState(false)
  const [startDateErr, setStartDateErr] = useState(false)
  const [endDateErr, setEndDateErr] = useState(false)
  const [initialEstiErr, setInitialEstiErr] = useState(false)
  const[initialminuteErr,setInitialMinuteErr] = useState(false)

  const handlerValidate = () => {
    let FormValid = true;

    if (taskpriority?.length === 0) {
      FormValid = false;
      setTaskPriorityErr(true);
    }
    else if (departmentName?.length === 0) {
      FormValid = false;
      setTaskDeptErr(true);
    }
    else if (projectname?.length === 0) {
      FormValid = false;
      setProjectNameErr(true);
    }
    else if (categoryname?.length === 0) {
      FormValid = false;
      setCategoryNameError(true);
    }
    else if (assignto?.length === 0) {
      FormValid = false;
      setAssignToErr(true);
    }
    else if (proposedStartDate?.length === 0) {
      FormValid = false;
      setStartDateErr(true);
    }
    else if (proposedEndDate.length === 0) {
      FormValid = false;
      setEndDateErr(true);
    }
    else if (initialHr?.length === 0) {
      FormValid = false;
      setInitialEstiErr(true);

    }else if(initialminute?.length === 0){
      FormValid = false;
      setInitialMinuteErr(true);
    }

    return FormValid;
  };


  // custom hook 
  const { allDepartmentOptionsById } = useGetDepartments()
  const { allProjectOptionsById } = useGetAllProjects()
  const { allCategoriesOptions } = useGetAllCategories()

  // for departmentwiseassignto 
  const payload = userDataDept !== userDept?
    {
      "departmentName": departmentName ? [departmentName.label] : "",
    }
    :
    {
       "departments": departmentName?.label ? [departmentName.label] : loginUserData.department.map((itm) => itm.label),
       "empId": ""
    }

  const urlEndpoint = userDataDept === userDept ? '/emp/getEmployeeByDepartment' : '/department/getDepartmentTL'
  const {allAssignToOptions} = useGetAssignTo(urlEndpoint,payload,departmentName,loginUserData.department.map((itm) => itm.label));


  const handleSubmit = async(e) => {
    setTaskPriorityErr(false)
    setTaskDeptErr(false)
    setProjectNameErr(false)
    setCategoryNameError(false)
    setAssignToErr(false)
    setStartDateErr(false)
    setEndDateErr(false)
    setInitialEstiErr(false)
    setInitialMinuteErr(false)

    // axios.post
    if (handlerValidate()) {
      if(parseFloat(initialHr) === 0 && parseFloat(initialminute) === 0){
        InitialHrMinute();
      }else{
      const payload = {
        "empId": assignto?.value,
        "taskName": item?.title,
        "taskDescription": item?.description,
        "taskPriority": taskpriority?.value,
        "department_id": (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.value : loginUserData?.department[0]?.value,
        "departmentName": (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.label : loginUserData?.department[0]?.label,
        "taskDepartmentId": departmentName.value,
        "taskDepartmentName": departmentName.label,
        "projectId": projectname.value,
        "projectName": projectname.label,
        "AssignTask": "",
        "assignBy_id": loginUserData?.empId,
        "assignBy_Name": `${loginUserData?.firstName} ${loginUserData?.lastName}`,
        "resource_id": assignto.value,
        "resourceName": assignto.label,
        "categoryOfName": categoryname.label,
        "category_id": categoryname.value,
        "proposedStartDate": new Date(proposedStartDate).toISOString().split('T')[0],
        "proposedEndDate": new Date(proposedEndDate).toISOString().split('T')[0],
        "initialEstimateHr": initialHr,
        "initialEstimateMinutes":initialminute,
        "estimateHr": "",
        "status": "pending",
        "logStatus": {
          "status": "pending",
          "resource_id": assignto.value,
          "resourceName": assignto.label
        }
      }

      await axios.post(process.env.REACT_APP_BASE_URL + '/task/addTask', payload)
        .then((res) => {
          setTaskpriority("")
          setDepartmentName("")
          setProjectname("")
          setCategoryname("")
          setAssignto("")
          setProposedStartDate("")
          setProposedEndDate("")
          setInitialHr("")
          setInitialMinute("")
          AddTaskSuccess();
          handlerDelete();
          close();
          fetchData();
        })
        .catch((err) => {
          console.log("Error", err)
        })
    }
  }

  }
  return (
    <>
     <ToastContainer autoClose = {5000}/>
    <Modal show={show} onHide={close} size="lg" centered backdrop='static' keyboard={false}>
      <Modal.Header closeButton className="mngmodelheader">
        <Modal.Title><h5>Create Task</h5></Modal.Title>
      </Modal.Header>
      <Modal.Body size="lg">
        <Row className='mb-4'>
          <Col sm={12} md={6}>
            <Form.Group controlId="formBasicId">
              <Form.Label className="mt-3 fw-bold">
                Task Title
                <span className="requiredfield">*</span>
              </Form.Label>
              <InputGroup>
                <Form.Control
                  placeholder="Task Name"
                  className="input-field project-inputgroup"
                  name="taskName"
                  value = {item?.title}
                  readOnly
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col sm={12} md={6}>
            <Form.Group className="">
              <Form.Label className="emp-form-label mt-3 fw-bold">
                Task Priority
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={taskpriority}
                options={taskPriorityOptions}
                onChange={(option) => {
                  setTaskpriority(option);
                  taskpriority?.length < 0
                    ? setTaskPriorityErr(true)
                    : setTaskPriorityErr(false)
                }}
              />
              {taskPriorityErrr ? (
                <p className="errMsg" >
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <Row className='mb-4'>
          <Col sm={12} md={12}>
            <Form.Group className="">
              <Form.Label className="mt-3 fw-bold">
                Task Description{" "}
                <span className="requiredfield">*</span>
              </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Task Description"
                  name='taskdescription'
                  value = {item?.description}
                  readOnly
                />
            </Form.Group>
          </Col>
        </Row>

        <Row className='mb-4'>
          <Col sm={12} md={6}>
            <Form.Group className="">
              <Form.Label className="mt-3 fw-bold">
                Department Name
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={departmentName}
                options={allDepartmentOptionsById}
                onChange={(option) => {
                  setDepartmentName(option);
                  setAssignto(null);
                  setCategoryname(null)
                  departmentName?.length < 0
                    ? setTaskDeptErr(true)
                    : setTaskDeptErr(false);
                }}
              />
              {tastDeptErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={6}>
            <Form.Group className="">
              <Form.Label className="mt-3 fw-bold">
                Project Name
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={projectname}
                options={allProjectOptionsById}
                onChange={(option) => {
                  setProjectname(option);
                  projectname?.length < 0
                    ? setProjectNameErr(true)
                    : setProjectNameErr(false);
                }}
              />
              {projectNameErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <Row className='mb-4'>
          <Col sm={12} md={4}>
            <Form.Group className="">
              <Form.Label className="emp-form-label mt-3 fw-bold">
                Category Name
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={categoryname}
                options={allCategoriesOptions}
                onChange={(option) => {
                  setCategoryname(option);
                  categoryname?.length < 0
                    ? setCategoryNameError(true)
                    : setCategoryNameError(false);
                }}
              />
              {categoryNameError ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={4}>
            <Form.Group className="">
              <Form.Label className="mt-3 fw-bold">
                Assign To
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={assignto}
                // options={useGetDeptwiseAssignTo}
                options = {allAssignToOptions}
                onChange={(option) => {
                  setAssignto(option);
                  assignto?.length < 0
                    ? setAssignToErr(true)
                    : setAssignToErr(false);
                }}
              />
              {assignToErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={4}>
            <Form.Group controlId="formBasicId">
              <Form.Label className="mt-3 fw-bold">
                Assign By
              </Form.Label>
              <Form.Control value={`${loginUserData?.firstName} ${loginUserData?.lastName}`} readOnly />
            </Form.Group>
          </Col>
        </Row>

        <Row className='mb-4'>
          <Col sm={12} md={3}>
            <Form.Group controlId="formBasiContact" className="w-100">
              <Form.Label className="mt-3 fw-bold">
                Proposed Start date{" "}
                <span className="requiredfield">*</span>
              </Form.Label>
                <Form.Control
                  className=""
                  type="date"
                  name="proposedStartDate"
                  value={proposedStartDate}
                  // min={new Date().toISOString().split("T")[0]}
                  onKeyDown={(event) => event.preventDefault()}
                  onChange={(e) => {
                    setProposedStartDate(e.target.value);
                    proposedStartDate?.length < 0
                      ? setStartDateErr(true)
                      : setStartDateErr(false);
                  }}
                />
              {startDateErr ? (
                <p className="errMsg" >
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={3}>
            <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
              <Form.Label className="mt-3 fw-bold">
                Proposed End date{" "}
                <span className="requiredfield">*</span>
              </Form.Label>
                <Form.Control
                  className=""
                  type="date"
                  name='proposedEndDate'
                  value={proposedEndDate}
                  min={proposedStartDate}
                  disabled={
                    proposedStartDate?.length === 0 ? true : false
                  }
                  onChange={(e) => {
                    setProposedEndDate(e.target.value);
                    proposedEndDate?.length < 0
                      ? setEndDateErr(true)
                      : setEndDateErr(false);
                  }}
                />
              {endDateErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={3}>
            <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
              <Form.Label className="mt-3 fw-bold">
                Initial Estimate(Hours){" "}
                <span className="requiredfield">*</span>
              </Form.Label>
                <Form.Control
                  type="text"
                  name="initialEstimateHr"
                  value={initialHr}
                  onChange={(e) => {
                    if(/^[0-9]*(\.[0-9]*)?$/.test(e.target.value) && e.target.value.length <= 4){
                        setInitialHr(e.target.value);
                      } else if (e.target.value.length === 0) {
                        setInitialHr(e.target.value);
                      }
                    initialHr?.length < 0
                      ? setInitialEstiErr(true)
                      : setInitialEstiErr(false);
                  }}
                />
              {initialEstiErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
          <Col sm={12} md={3}>
            <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
              <Form.Label className="mt-3 fw-bold">
                Initial Minutes{" "}
                <span className="requiredfield">*</span>
              </Form.Label>
                <Form.Control
                  type="text"
                  className=""
                  name="initialminute"
                  value={initialminute}
                  onChange={(e) => {
                    if(/^[0-9]{0,2}$/.test(e.target.value) && e.target.value >= 0 && e.target.value <= 59){
                        setInitialMinute(e.target.value);
                      } else if (e.target.value > 59) {
                         toast.error('Please enter a value between 0 and 59.')}
                        else if (e.target.value.length === 0) {
                        setInitialMinute(e.target.value);
                      }
                    initialminute?.length < 0
                      ? setInitialMinuteErr(true)
                      : setInitialMinuteErr(false);
                  }}
                />
              {initialminuteErr ? (
                <p className="errMsg">
                  <>
                    <Icon.ExclamationTriangle className="me-2" />
                  </>
                  Required Field
                </p>
              ) : null}
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="text-center mt-4">
        <Button className="primaryBtn " onClick={() => handleSubmit() }>
          <Icon.PersonAdd className='me-2' /> Create Task
        </Button>
      </Modal.Footer>
    </Modal>
    </>
    
  )
}

export default AssignToDoModel